<div class="flex h-full">
  @if (isQuickModalOpen()) {
    <div class="action-panel">
      <section class="h-full flex flex-col overflow-hidden">
        @if (selectedAction() && selectedAction()!.clickAction !== 'SETTINGS') {
          <div class="flex items-center justify-between p-2 border-b border-[#EAECF0]">
            <p class="text-[13px] text-[#475467] font-semibold pt-2 pl-2">
              {{ selectedAction()!.label }}
              @if (selectedAction()!.clickAction === 'INSIGHTS') {
                <button class="p-2" title="Regenerate Insights">
                  <ui-icon name="reload" class="stroke-[2px] stroke-[#5D5D5D] hover:stroke-[#0F49A0]"></ui-icon>
                </button>
              }
            </p>
            <ui-icon
              name="rounded-close"
              class="stroke-[#475467] stroke-2 cursor-pointer pt-2"
              size="size-4"
              (click)="closeQuickActionModal()"
            />
          </div>
        }

        <div class="flex-grow overflow-auto">
          @switch (selectedAction()?.clickAction) {
            @case ('REFRESH') {
              <div class="p-4">
                <!-- Empty refresh container -->
              </div>
            }
            @case ('SETTING') {
              <div class="h-full">
                <div class="p-4">
                  <!-- Settings content will be added later -->
                </div>
              </div>
            }
            @case ('INSIGHTS') {
              <div class="h-full overflow-hidden">
                <div class="h-[90%] overflow-auto px-4 pt-2">
                  <div class="text-center text-gray-500 mt-8">
                    Insights feature coming soon
                  </div>
                </div>
              </div>
            }
            @case ('COPILOT') {
              <div class="h-full">
                <app-copilot-modal
                  [selectedScope]="''"
                  [conversations]="localConversations()"
                  [canvasId]="canvasId()"
                  [assetModelId]="assetModelId"
                  [selectedReportIds]="selectedReportIds()"
                  [selectedAnswerIds]="selectedAnswerIds()"
                  [cards]="cards()"
                  (emitConversations)="onConversations($event)"
                  [type]="'CANVAS'"
                  [handleApiInParent]="true"
                  (askQuestion)="onAskQuestion($event)"
                ></app-copilot-modal>
              </div>
            }
            @case ('SAVE') {
              @if (saveCanvasLoading()) {
                <div class="flex flex-col justify-center items-center h-full">
                  <app-loader [loadingText]="'Saving canvas..'" />
                </div>
              } @else {
                <div class="h-full flex flex-col">
                  @if (saveCanvasSuccessful()) {
                    <div class="flex items-start justify-between mt-4 p-4 border border-[#6CE9A6] rounded-lg bg-[#F6FEF9] mx-4">
                      <div class="flex items-center">
                        <ui-icon name="check-circle" class="stroke-[#079455] stroke-2" size="size-4"></ui-icon>
                        <div class="mx-4 text-[#079455]">
                          <p class="font-semibold text-sm">Canvas saved successfully</p>
                        </div>
                      </div>
                      <div (click)="toggleSaveCanvasSuccessful()" class="cursor-pointer p-1">
                        <ui-icon name="rounded-close" class="stroke-[#475467] stroke-2" size="size-4"></ui-icon>
                      </div>
                    </div>
                  }
                  @if (saveCanvasError()) {
                    <div class="flex items-start justify-between my-4 p-4 border border-[#FDA29B] rounded-lg bg-[#FFFBFA] mx-4">
                      <ui-icon name="alert-circle" class="stroke-[#B42318] stroke-2" size="size-4"></ui-icon>
                      <div class="mx-4 text-[#B42318]">
                        <p class="font-semibold text-sm">Error saving canvas</p>
                        <p class="text-xs">Please try again.</p>
                      </div>
                      <div (click)="toggleSaveCanvasError()" class="cursor-pointer p-1">
                        <ui-icon name="rounded-close" class="stroke-[#475467] stroke-2" size="size-4"></ui-icon>
                      </div>
                    </div>
                  }

                  <div class="flex-grow overflow-auto mx-4">
                    <div class="mt-4">
                      <label for="canvasName" class="block text-sm font-medium text-[#344054]">Canvas name</label>
                      <input type="text" id="canvasName"
                        [ngModel]="canvasName()"
                        (ngModelChange)="canvasName.set($event)"
                        class="mt-1 block w-full p-2 border border-[#D0D5DD] rounded-md shadow-sm focus:outline-none focus:ring-[#1570EF] focus:border-[#1570EF] sm:text-sm"
                        [ngClass]="{'border-red-500': isCanvasNameEmpty()}"
                        placeholder="Enter canvas name">
                      @if (isCanvasNameEmpty()) {
                        <p class="text-xs text-red-500 mt-1">Canvas name is required</p>
                      }
                    </div>

                    <div class="mt-4">
                      <label for="canvasDescription" class="block text-sm font-medium text-[#344054]">Description</label>
                      <textarea id="canvasDescription" rows="3"
                        [ngModel]="canvasDescription()"
                        (ngModelChange)="canvasDescription.set($event)"
                        class="mt-1 block w-full p-2 border border-[#D0D5DD] rounded-md shadow-sm focus:outline-none focus:ring-[#1570EF] focus:border-[#1570EF] sm:text-sm"
                        placeholder="Add a description for this canvas"></textarea>
                    </div>

                    <div class="mt-4">
                      <label class="block text-sm font-medium text-[#344054]">Tags</label>
                      <div class="flex flex-wrap items-center mt-1 p-2 border border-[#D0D5DD] rounded-md">
                        @for (tag of tags(); track tag) {
                          <span class="inline-flex items-center px-2.5 py-0.5 rounded-md text-sm font-medium bg-[#F2F4F7] text-[#344054] mr-2 mb-2">
                            {{tag}}
                            <button type="button" class="ml-1 inline-flex" (click)="removeTag(tag)">
                              <ui-icon name="rounded-close" class="stroke-[#475467] stroke-2" size="size-3"></ui-icon>
                            </button>
                          </span>
                        }
                        <input type="text" class="tag-input"
                          [ngModel]="tagInput()"
                          (ngModelChange)="tagInput.set($event)"
                          (keydown)="onKeydown($event)"
                          placeholder="Add tags...">
                      </div>
                    </div>
                  </div>

                  <div class="flex-shrink-0 w-full border-t border-[#EAECF0] pt-4 pb-4 bg-white">
                    @if (redirecting()) {
                      <p class="text-center w-full">
                        Redirecting to saved canvas in
                        <span class="font-bold text-[#0F49A0]">{{ redirectTime }}s</span>
                      </p>
                    } @else {
                      <div class="flex justify-end gap-2 px-4">
                        <button (click)="closeQuickActionModal()"
                          class="px-4 py-2 text-[#344054] bg-white border border-[#D0D5DD] rounded-md hover:bg-gray-50">
                          Cancel
                        </button>
                        <button (click)="onSaveCanvas()"
                          [disabled]="saveCanvasLoading()"
                          class="px-4 py-2 text-white bg-[#1570EF] rounded-md hover:bg-[#175CD3] disabled:opacity-50 disabled:cursor-not-allowed">
                          Save Canvas
                        </button>
                      </div>
                    }
                  </div>
                </div>
              }
            }
          }
        </div>
      </section>
    </div>
  }

  <div class="border-l border-[#EAECF0] p-3 flex flex-col items-center gap-3">
    @for (action of quickActions; track action.clickAction) {
      <div
        (click)="!action.disabled && onQuickActionClick(action)"
        class="p-2 rounded-[4px] cursor-pointer"
        [ngClass]="{
          'bg-[#C3D9FA]': actionName() === action.clickAction || (action.clickAction === 'LOCK' && isCanvasLocked()),
          'bg-[#F2F4F7] hover:bg-[#C3D9FA]': actionName() !== action.clickAction && !(action.clickAction === 'LOCK' && isCanvasLocked()),
          'opacity-50 cursor-not-allowed': action.disabled
        }"
        [title]="action.disabled ? (action.clickAction === 'REFRESH' ? 'Save canvas to enable refresh' : action.label + ' (disabled)') : action.label">
        @if (action.clickAction === 'LOCK') {
          @if (isCanvasLocked()) {
            <ui-icon name="lock-closed" [ngClass]="getIconClasses(action)" size="size-4"></ui-icon>
          } @else {
            <ui-icon name="lock-open" [ngClass]="getIconClasses(action)" size="size-4"></ui-icon>
          }
        } @else {
          <ui-icon [name]="action.name" [ngClass]="getIconClasses(action)" size="size-4"></ui-icon>
        }
      </div>
    }
  </div>
</div>

<!-- Confirmation Popup -->
<app-confirmation-popup
  [isVisible]="showConfirmationPopup()"
  [message]="confirmationPopupMsg()"
  [header]="confirmationPopupHeader()"
  [confirmAction]="confirmationCallbacks.confirmAction"
  [cancelAction]="confirmationCallbacks.cancelAction">
</app-confirmation-popup>
